import { render, staticRenderFns } from "./SelectCliente.vue?vue&type=template&id=f9036aaa"
import script from "./SelectCliente.vue?vue&type=script&lang=js"
export * from "./SelectCliente.vue?vue&type=script&lang=js"
import style0 from "./SelectCliente.vue?vue&type=style&index=0&id=f9036aaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports